import AxiosInstance from '../../core/api/axiosinstance'
import { promiseToResult } from '../../utils'

export interface Type {
  value: string
  key: number
}
export interface Defaults {
  auth: {
    types: Type[]
  }
  payments: {
    discounts: {
      types: Type[]
      conditions: Type[]
    }
    types: Type[]
  }
  transactions: {
    types: Type[]
  }
  users: {
    roles: Type[]
  }
  verifications: {
    types: Type[]
  }
}

export type GetDefaultsRes = Defaults
const getDefaults = () => {
  return promiseToResult(AxiosInstance().get<GetDefaultsRes>(
    '/application/defaults/values',
  ))
}

export interface GetUserRes {
  country: string
  city: string
  ip: string
}
const getUser = () => {
  return promiseToResult(AxiosInstance().get<GetUserRes>(
    '/application/defaults/user',
  ))
}

export const DefaultsAPI = {
  getDefaults,
  getUser,
}
